import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { localhostRedirectStorageKey } from '@app/constants';

@Injectable({
  providedIn: 'root'
})
export class LocalRedirectionService {

  onChangeRedirect$ = new BehaviorSubject<boolean>(
    localStorage.getItem(localhostRedirectStorageKey) === '1' ? true : false
  );

  set(state: boolean): void {
    this.onChangeRedirect$.next(state);
  }

}
